// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 401) return "vendor/bcr.0db52c05ed55cbd5e3c8.js";
	if (chunkId === 5322) return "vendor/bcr.181c65c517f4ff75341e.js";
	if (chunkId === 82) return "vendor/bcr.506b95b6cf200c6889f8.js";
	if (chunkId === 2716) return "vendor/bcr.d45f205e05fd77ab49ab.js";
	if (chunkId === 3624) return "vendor/bcr.b797d950af525e03a11f.js";
	if (chunkId === 7253) return "vendor/bcr.4efe456c698c4da61e93.js";
	if (chunkId === 9060) return "vendor/bcr.e24d782eee5e21c2bd03.js";
	if (chunkId === 8478) return "vendor/bcr.39c41f08b7e30b538b68.js";
	if (chunkId === 4484) return "vendor/bcr.6c9760db674ffb215ce6.js";
	if (chunkId === 9480) return "vendor/bcr.cc3906965e4117ecae0c.js";
	if (chunkId === 5391) return "vendor/bcr.6ca4d081cc7fddbfeb94.js";
	if (chunkId === 6892) return "vendor/bcr.fa34a312771de6a343a9.js";
	if (chunkId === 6804) return "vendor/bcr.5b99fc41fa91da0d472b.js";
	if (chunkId === 8460) return "vendor/react.20844442fdd87ad0c147.js";
	if (chunkId === 4459) return "vendor/react.4e167f69385c9b2ac8a6.js";
	if (chunkId === 1393) return "vendor/react.973c0bed9fb43cdf15ff.js";
	if (chunkId === 5908) return "vendor/react.93758be115eb4d75ad65.js";
	if (chunkId === 6463) return "vendor/react.46729de6da49177bce32.js";
	if (chunkId === 5726) return "vendor/react.8f84e037b597c8e3569e.js";
	if (chunkId === 3074) return "vendor/react.dc1a3cc78a4f1fb4aab2.js";
	if (chunkId === 4118) return "vendor/react.a3dcfe6df66379c81e25.js";
	// return url for filenames based on template
	return "c964f7c/chunk-" + chunkId + ".js";
};